<template>
  <pagefra>
    <div class="lcdEquipment container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('电梯工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('楼盘名称')">
              <el-input
                v-model="form.building"
                :placeholder="$l('楼盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="DeviceNo"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('分公司')"
              prop="Filiale"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="City"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('楼盘')"
              prop="Building"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯位置')"
              prop="InstallSite"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('卡号-端口')"
              prop="Phone"
              align="center"
              width="150"
              :formatter="phoneFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('合同状态')"
              prop="IsService"
              align="center"
              width="120"
              :formatter="isServiceFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('屏幕组成')"
              prop="ScreenComposition"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('投放状态')"
              prop="IssueStatus"
              align="center"
              width="120"
              :formatter="issueStatusFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('显示方案')"
              prop="DisPlayName"
              align="center"
              width="120"
              :formatter="displayFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('公告下发')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('公告下发')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openIssue(scope.row)"
                  class="table-icon"
                >
                  <svgicon name="issue" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('下发记录')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('下发记录')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="viewIssue(scope.row.Id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        ref="issueDialog"
        :title="$l('公告下发')"
        :visible.sync="issueDialogVisible"
        width="640px"
      >
        <el-form
          ref="issueForm"
          :model="issueForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="rules"
        >
          <el-form-item :label="$l('有效时长')" prop="effectiveDuration">
            <el-input-number
              v-model="issueForm.effectiveDuration"
              :min="1"
              :max="999999999"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$l('时间段1')">
            <el-time-picker v-model="startTimeSlot1" format="HH:mm">
            </el-time-picker>
            --
            <el-time-picker v-model="endTimeSlot1" format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <el-form-item :label="$l('时间段2')">
            <el-time-picker v-model="startTimeSlot2" format="HH:mm">
            </el-time-picker>
            --
            <el-time-picker v-model="endTimeSlot2" format="HH:mm">
            </el-time-picker>
          </el-form-item>
          <el-form-item :label="$l('公告内容')" prop="issueContent">
            <el-input
              type="textarea"
              v-model="issueForm.issueContent"
            ></el-input>
          </el-form-item>
          <el-form-item class="risk-tip-item">
            <el-checkbox v-model="isAgreeRiskTip">{{
              $l("我已阅读并同意")
            }}</el-checkbox>
            <span class="risk-tip-text" @click="$refs.risk.show()">{{
              $l("《风险提示书》")
            }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="issueDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="issue"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <issueLogDialog ref="issueLog" @onEdit="showEdit"></issueLogDialog>
      <riskTipDialog ref="risk" @agree="agreeRiskTip()"></riskTipDialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import issueLogDialog from "@/components/issueLogDialog.vue";
import riskTipDialog from "@/components/riskTipDialog.vue";
import global from "@/mixins/global.js";
export default {
  name: "lcdEquipment",
  mixins: [global],
  components: {
    panel,
    issueLogDialog,
    riskTipDialog,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateContent = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入公告内容")));
      } else {
        callback();
      }
    };
    return {
      form: {
        jobNum: "",
        building: "",
      },
      tableData: [],
      loading: false,
      issueForm: {
        effectiveDuration: 24,
        startTimeSlot1: "",
        endTimeSlot1: "",
        startTimeSlot2: "",
        endTimeSlot2: "",
        lcdId: "",
        elevatorId: "",
        deviceNo: "",
        issueContent: "",
        issueId: null,
      },
      rules: {
        issueContent: [
          { validator: validateContent, trigger: "blur" },
          {
            min: 1,
            max: 40,
            message: this.$l("不能超过40个字符"),
            trigger: "blur",
          },
        ],
      },
      startTimeSlot1: new Date(1971, 1, 1, 0, 0, 0),
      endTimeSlot1: new Date(1971, 1, 1, 0, 0, 0),
      startTimeSlot2: new Date(1971, 1, 1, 0, 0, 0),
      endTimeSlot2: new Date(1971, 1, 1, 0, 0, 0),
      issueDialogVisible: false,
      isAgreeRiskTip: false,
      isAgreeAndIssue: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_lcd_equipment_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openIssue(row) {
      this.issueDialogVisible = true;
      this.issueForm.lcdId = row.Id;
      this.issueForm.elevatorId = row.ElevatorID;
      this.issueForm.deviceNo = row.DeviceNo;
      this.isAgreeRiskTip = false;
    },
    issue() {
      this.$refs.issueForm.validate((valid) => {
        if (valid) {
          if (!this.issueForm.effectiveDuration) {
            this.message(1, "有效时长不能为空");
            return;
          }
          if (
            !this.startTimeSlot1 ||
            !this.endTimeSlot1 ||
            !this.startTimeSlot2 ||
            !this.endTimeSlot2
          ) {
            this.message(1, "选择时间");
            return;
          }
          if (
            this.startTimeSlot1.getTime() > this.endTimeSlot1.getTime() ||
            this.startTimeSlot2.getTime() > this.endTimeSlot2.getTime()
          ) {
            this.message(1, "开始时间不能大于结束时间");
            return;
          }
          if (this.issueForm.issueContent.trim().length == 0) {
            this.message(1, "公告内容不能为空");
            return;
          }
          this.issueForm.startTimeSlot1 = this.$common.formatTime(
            this.startTimeSlot1
          );
          this.issueForm.endTimeSlot1 = this.$common.formatTime(
            this.endTimeSlot1
          );
          this.issueForm.startTimeSlot2 = this.$common.formatTime(
            this.startTimeSlot2
          );
          this.issueForm.endTimeSlot2 = this.$common.formatTime(
            this.endTimeSlot2
          );
          if (!this.isAgreeRiskTip) {
            this.$refs.risk.show();
            this.isAgreeAndIssue = true;
            return;
          }
          this.$http
            .post(this.$apiConfig.lcd_equipment_issue_url, this.issueForm)
            .then((response) => {
              let data = response.data;
              if (data.code == 0) {
                this.message(data.code, data.msg + "，待审核");
                this.issueDialogVisible = false;
                if (this.issueForm.issueId) {
                  this.$refs.issueLog.update();
                }
              } else {
                this.message(data.code, data.msg);
              }
              this.issueForm.issueId = null;
            })
            .catch((error) => {
              this.issueForm.issueId = null;
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    viewIssue(lcdId) {
      this.$refs.issueLog.open(lcdId);
    },
    showEdit(row) {
      this.issueDialogVisible = true;
      for (const key in row) {
        this.issueForm[key] = row[key];
      }
    },
    phoneFormatter(row) {
      return row.Phone ? row.Phone + "-" + row.TerminalPort : "";
    },
    isServiceFormatter(row) {
      if (row.IsService) {
        return "在保";
      } else {
        return "脱保";
      }
    },
    issueStatusFormatter(row) {
      if (row.IssueStatus) {
        return "允许";
      } else {
        return "禁止";
      }
    },
    displayFormatter(row) {
      return row.PlanCode + row.DisPlayName;
    },
    agreeRiskTip() {
      this.isAgreeRiskTip = true;
      if (this.isAgreeAndIssue) {
        this.issue();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.lcdEquipment {
  /deep/ .dialog-form {
    .el-input {
      width: 300px;
    }
    .el-textarea {
      width: 400px;
      .el-textarea__inner {
        height: 134px;
      }
    }
    .el-date-editor {
      width: 140px;
    }
    .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
      width: 300px;
    }
  }
  .risk-tip-item {
    .risk-tip-text {
      color: red;
      cursor: pointer;
    }
  }
  /deep/.risk-tip-dialog {
    .el-dialog__body {
      padding: 10px 20px;
      color: black;
    }
  }
}
</style>
